import { BlockedSlotInfoModel, CourtBookingInfoModel, CourtClassInfoModel } from '@bayclubs/court-booking-employee-api';
import { Spinner, BcStateContext, BcStateForm } from '@bayclubs/state';

export const COURT_EVENT_INFO_FEATURE_KEY = 'cbCourtEventInfo';

export interface CourtEventInfoStateModel {
    spinner: Spinner;
    blockedSlotDetails: BcStateContext<BlockedSlotInfoModel>;
    courtBookingDetails: BcStateContext<CourtBookingInfoModel>;
    courtClassDetails: BcStateContext<CourtClassInfoModel>;
}
